import { useId } from "react";
import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Logo Icons
const RedditIcon = ({
  className,
  size = 16,
  x,
  y,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => {
  const id = useId();

  return (
    <OpticksSvgElement
      className={`icon-reddit${className ? ` ${className}` : ""}`}
      size={size}
      aria-label={ariaLabel}
      viewBox="0 0 16 16"
      fill="none"
      x={x}
      y={y}
    >
      <title>Reddit</title>
      <path
        d="M8 2C4.68594 2 2 4.68594 2 8C2 9.65938 2.67031 11.1594 3.75781 12.2422L2.61406 13.3859C2.38906 13.6109 2.54844 14 2.86719 14H8C11.3141 14 14 11.3141 14 8C14 4.68594 11.3141 2 8 2Z"
        fill="#FF4500"
      />
      <path
        d="M11.4031 9.19999C12.1772 9.19999 12.8047 8.57249 12.8047 7.79843C12.8047 7.02437 12.1772 6.39687 11.4031 6.39687C10.6291 6.39687 10.0016 7.02437 10.0016 7.79843C10.0016 8.57249 10.6291 9.19999 11.4031 9.19999Z"
        fill={`url(#${id}-0)`}
      />
      <path
        d="M4.59688 9.19999C5.37094 9.19999 5.99844 8.57249 5.99844 7.79843C5.99844 7.02437 5.37094 6.39687 4.59688 6.39687C3.82281 6.39687 3.19531 7.02437 3.19531 7.79843C3.19531 8.57249 3.82281 9.19999 4.59688 9.19999Z"
        fill={`url(#${id}-1)`}
      />
      <path
        d="M8.00466 11.9984C10.2129 11.9984 12.0031 10.6553 12.0031 8.99843C12.0031 7.34157 10.2129 5.99843 8.00466 5.99843C5.79639 5.99843 4.00623 7.34157 4.00623 8.99843C4.00623 10.6553 5.79639 11.9984 8.00466 11.9984Z"
        fill={`url(#${id}-2)`}
      />
      <path
        d="M6.81874 8.70781C6.7953 9.21406 6.4578 9.40155 6.06405 9.40155C5.6703 9.40155 5.3703 9.13905 5.39374 8.6328C5.41718 8.12655 5.75468 7.78905 6.14843 7.78905C6.54218 7.78905 6.84218 8.20156 6.81874 8.70781Z"
        fill="#842123"
      />
      <path
        d="M10.6062 8.6328C10.6297 9.13905 10.3297 9.40155 9.9359 9.40155C9.54215 9.40155 9.20465 9.21874 9.18122 8.70781C9.15778 8.20156 9.45778 7.78905 9.85153 7.78905C10.2453 7.78905 10.5828 8.12187 10.6062 8.6328Z"
        fill="#842123"
      />
      <path
        d="M9.18591 8.75468C9.20935 9.22812 9.52341 9.40155 9.88904 9.40155C10.2547 9.40155 10.5359 9.14374 10.5172 8.66562C10.4937 8.19218 10.1797 7.87812 9.81404 7.87812C9.44841 7.87812 9.16248 8.27655 9.18591 8.75468Z"
        fill={`url(#${id}-3)`}
      />
      <path
        d="M6.81877 8.75468C6.79533 9.22812 6.48127 9.40155 6.11565 9.40155C5.75002 9.40155 5.46877 9.14374 5.49221 8.66562C5.51565 8.19218 5.82971 7.87812 6.19533 7.87812C6.56096 7.87812 6.84221 8.27655 6.81877 8.75468Z"
        fill={`url(#${id}-4)`}
      />
      <path
        d="M8.00464 9.73905C7.50776 9.73905 7.03432 9.76249 6.5937 9.80468C6.5187 9.81405 6.47182 9.88905 6.49995 9.95468C6.7437 10.5312 7.32495 10.9391 8.00464 10.9391C8.68432 10.9391 9.26089 10.5359 9.50932 9.95468C9.53745 9.88436 9.49057 9.80936 9.41557 9.80468C8.97495 9.76249 8.50151 9.73905 8.00464 9.73905Z"
        fill="#BBCFDA"
      />
      <path
        d="M8.00471 9.85155C7.50784 9.85155 7.0344 9.87499 6.59846 9.92187C6.52346 9.93124 6.47658 10.0062 6.50471 10.0766C6.74846 10.6625 7.32971 11.075 8.00471 11.075C8.67971 11.075 9.26096 10.6625 9.50471 10.0766C9.53284 10.0062 9.48596 9.93124 9.41096 9.92187C8.97034 9.87499 8.4969 9.85155 8.00471 9.85155Z"
        fill="white"
      />
      <path
        d="M8.00471 9.79062C7.51721 9.79062 7.05315 9.81405 6.6219 9.85624C6.5469 9.86562 6.50002 9.94062 6.52815 10.0062C6.7719 10.5828 7.33909 10.9906 8.00471 10.9906C8.67034 10.9906 9.23752 10.5875 9.48127 10.0062C9.5094 9.93593 9.46252 9.86093 9.38752 9.85624C8.95627 9.81874 8.49221 9.79062 8.00471 9.79062Z"
        fill={`url(#${id}-5)`}
      />
      <path
        d="M10.1937 5.5953C10.7425 5.5953 11.1875 5.15039 11.1875 4.60155C11.1875 4.05272 10.7425 3.6078 10.1937 3.6078C9.64487 3.6078 9.19995 4.05272 9.19995 4.60155C9.19995 5.15039 9.64487 5.5953 10.1937 5.5953Z"
        fill={`url(#${id}-6)`}
      />
      <path
        d="M7.99065 6.12499C7.87346 6.12499 7.77502 6.07343 7.77502 5.99843C7.77502 5.1078 8.4969 4.38593 9.38752 4.38593C9.50471 4.38593 9.60315 4.48437 9.60315 4.60155C9.60315 4.71874 9.50471 4.81718 9.38752 4.81718C8.73596 4.81718 8.20627 5.34687 8.20627 5.99843C8.20627 6.07812 8.10784 6.12499 7.99065 6.12499Z"
        fill={`url(#${id}-7)`}
      />
      <path
        d="M6.56096 8.98906C6.56096 9.17187 6.36409 9.25624 6.12502 9.25624C5.88596 9.25624 5.68909 9.17187 5.68909 8.98906C5.68909 8.80624 5.88596 8.65624 6.12502 8.65624C6.36409 8.65624 6.56096 8.80156 6.56096 8.98906Z"
        fill="#FF6101"
      />
      <path
        d="M10.3204 8.98906C10.3204 9.17187 10.1235 9.25624 9.88442 9.25624C9.64536 9.25624 9.44849 9.17187 9.44849 8.98906C9.44849 8.80624 9.64536 8.65624 9.88442 8.65624C10.1235 8.65624 10.3204 8.80156 10.3204 8.98906Z"
        fill="#FF6101"
      />
      <path
        d="M6.42495 8.48749C6.51038 8.48749 6.57964 8.41194 6.57964 8.31874C6.57964 8.22554 6.51038 8.14999 6.42495 8.14999C6.33952 8.14999 6.27026 8.22554 6.27026 8.31874C6.27026 8.41194 6.33952 8.48749 6.42495 8.48749Z"
        fill="#FFC49C"
      />
      <path
        d="M10.1234 8.48749C10.2089 8.48749 10.2781 8.41194 10.2781 8.31874C10.2781 8.22554 10.2089 8.14999 10.1234 8.14999C10.038 8.14999 9.96875 8.22554 9.96875 8.31874C9.96875 8.41194 10.038 8.48749 10.1234 8.48749Z"
        fill="#FFC49C"
      />
      <defs>
        <radialGradient
          id={`${id}-0`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.4225 7.04175) scale(2.80788 2.44943)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id={`${id}-1`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.61993 7.04175) scale(2.80788 2.44943)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id={`${id}-2`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.11 6.64886) scale(8.46969 5.94681)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id={`${id}-3`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.74747 9.07677) rotate(180) scale(0.707644 1.03888)"
        >
          <stop stopColor="#FF6600" />
          <stop offset="0.5" stopColor="#FF4500" />
          <stop offset="0.7" stopColor="#FC4301" />
          <stop offset="0.82" stopColor="#F43F07" />
          <stop offset="0.92" stopColor="#E53812" />
          <stop offset="1" stopColor="#D4301F" />
        </radialGradient>
        <radialGradient
          id={`${id}-4`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.2277 9.07677) scale(0.707644 1.03888)"
        >
          <stop stopColor="#FF6600" />
          <stop offset="0.5" stopColor="#FF4500" />
          <stop offset="0.7" stopColor="#FC4301" />
          <stop offset="0.82" stopColor="#F43F07" />
          <stop offset="0.92" stopColor="#E53812" />
          <stop offset="1" stopColor="#D4301F" />
        </radialGradient>
        <radialGradient
          id={`${id}-5`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.0173 11.1363) scale(2.49526 1.64581)"
        >
          <stop stopColor="#172E35" />
          <stop offset="0.29" stopColor="#0E1C21" />
          <stop offset="0.73" stopColor="#030708" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id={`${id}-6`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.2177 3.59871) scale(2.19035)"
        >
          <stop stopColor="#FEFFFF" />
          <stop offset="0.4" stopColor="#FEFFFF" />
          <stop offset="0.51" stopColor="#F9FCFC" />
          <stop offset="0.62" stopColor="#EDF3F5" />
          <stop offset="0.7" stopColor="#DEE9EC" />
          <stop offset="0.72" stopColor="#D8E4E8" />
          <stop offset="0.76" stopColor="#CCD8DF" />
          <stop offset="0.8" stopColor="#C8D5DD" />
          <stop offset="0.83" stopColor="#CCD6DE" />
          <stop offset="0.85" stopColor="#D8DBE2" />
          <stop offset="0.88" stopColor="#EDE3E9" />
          <stop offset="0.9" stopColor="#FFEBEF" />
        </radialGradient>
        <radialGradient
          id={`${id}-7`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.30503 5.98652) scale(1.79533)"
        >
          <stop offset="0.48" stopColor="#7A9299" />
          <stop offset="0.67" stopColor="#172E35" />
          <stop offset="0.75" />
          <stop offset="0.82" stopColor="#172E35" />
        </radialGradient>
      </defs>
    </OpticksSvgElement>
  );
};

export default RedditIcon;
